import request from '~/utils/request';

export const listSavedFilters = ({ module, subModule }) =>
  request.get('saved-filters', { module, subModule });

export const createSavedFilter = (payload) =>
  request.post('saved-filters', payload);

export const updateSavedFilter = (id, payload) =>
  request.put(`saved-filters/${id}`, payload);

export const deleteSavedFilter = (id) =>
  request.delete(`saved-filters/${id}`);
